module.exports = __webpack_public_path__ + "media/images/mobile/solutions/6-bd14b3c50f432dcc998806289df5aa5f.png";